import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import { ajax } from 'rxjs/ajax';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import merge from 'lodash/merge';
import isObject from 'lodash/isObject';
import { toast } from 'react-toastify';
var defaultHeaders = {
  'Content-Type': 'application/json'
};

var getKeycloakHeaders = function getKeycloakHeaders() {
  var kcToken = localStorage.getItem('kc_token');

  if (!kcToken) {
    return {};
  }

  return {
    Authorization: "Bearer ".concat(kcToken)
  };
};

var Api =
/*#__PURE__*/
function () {
  function Api() {
    _classCallCheck(this, Api);
  }

  _createClass(Api, null, [{
    key: "get",
    value: function get(url, query, headers, silent) {
      var _this = this;

      return ajax.get(Api.getUrl(url, query), merge(defaultHeaders, headers, getKeycloakHeaders())).pipe(catchError(function (error) {
        _this.errors(error, silent);

        return throwError(error);
      }));
    }
  }, {
    key: "post",
    value: function post(url, body, query, headers, silent) {
      var _this2 = this;

      return ajax.post(Api.getUrl(url, query), body, merge(defaultHeaders, headers, getKeycloakHeaders())).pipe(catchError(function (error) {
        _this2.errors(error, silent);

        return throwError(error);
      }));
    }
  }, {
    key: "put",
    value: function put(url, body, query, headers, silent) {
      var _this3 = this;

      return ajax.put(Api.getUrl(url, query), body, merge(defaultHeaders, headers, getKeycloakHeaders())).pipe(catchError(function (error) {
        _this3.errors(error, silent);

        return throwError(error);
      }));
    }
  }, {
    key: "patch",
    value: function patch(url, headers, silent) {
      var _this4 = this;

      return ajax.patch(Api.getUrl(url), merge(defaultHeaders, headers, getKeycloakHeaders())).pipe(catchError(function (error) {
        _this4.errors(error, silent);

        return throwError(error);
      }));
    }
  }, {
    key: "delete",
    value: function _delete(url, headers, silent) {
      var _this5 = this;

      return ajax.delete(Api.getUrl(url), merge(defaultHeaders, headers, getKeycloakHeaders())).pipe(catchError(function (error) {
        _this5.errors(error, silent);

        return throwError(error);
      }));
    }
  }, {
    key: "getJSON",
    value: function getJSON(url, query, headers, silent) {
      var _this6 = this;

      return ajax.getJSON(Api.getUrl(url, query), merge(defaultHeaders, headers, getKeycloakHeaders())).pipe(catchError(function (error) {
        _this6.errors(error, silent);

        return throwError(error);
      }));
    }
    /**
     * Обработка ошибок
     * @param error
     * @param silent
     */

  }, {
    key: "errors",
    value: function errors(error, silent) {
      // if (error.status === 403) {
      //   window.location.href = '/auth';
      // }
      if (!silent) {
        toast.error(error.response || error.message);
      }
    }
    /**
     * Формирование URL
     * @param url
     * @param query GET params
     */

  }, {
    key: "getUrl",
    value: function getUrl(url, query) {
      if (query === undefined) {
        return url;
      }

      var _url$split = url.split('?'),
          _url$split2 = _slicedToArray(_url$split, 2),
          baseUrl = _url$split2[0],
          searchParams = _url$split2[1];

      var p = new URLSearchParams(searchParams);

      for (var _i = 0, _Object$entries = Object.entries(query); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        p.set(key, isObject(value) ? JSON.stringify(value) : String(value));
      }

      return "".concat(baseUrl, "?").concat(p.toString());
    }
  }]);

  return Api;
}();

export { Api as default };